import './InputScreen.vars.css'

const responsiveStyles = {
  right: 'var(--input-right)',
  bottom: 'var(--input-bottom)',
  zIndex: 3
}

export default responsiveStyles
